/**
 * CTABand — full-width contrast strip used between sections.  Reuses theme
 * colours so brand changes propagate automatically.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { COLOR, FONT, RADIUS, ELEVATION } from '../../../components/ss/tokens';
import useSiteConfig from '../useSiteConfig';

function isExternal(href) {
  return /^(https?:|mailto:|tel:)/i.test(href || '');
}

function CTA({ link, primary }) {
  if (!link?.href) return null;
  const styles = primary
    ? {
        background: '#fff',
        color: COLOR.text,
        padding: '14px 26px',
        borderRadius: RADIUS.pill,
        fontSize: FONT.size.md,
        fontWeight: FONT.weight.semi,
        textDecoration: 'none',
        boxShadow: ELEVATION.md,
        display: 'inline-block',
      }
    : {
        background: 'transparent',
        color: '#fff',
        padding: '14px 26px',
        borderRadius: RADIUS.pill,
        fontSize: FONT.size.md,
        fontWeight: FONT.weight.semi,
        textDecoration: 'none',
        border: '1px solid rgba(255,255,255,0.4)',
        display: 'inline-block',
      };
  if (isExternal(link.href) || link.href.includes('#')) {
    return <a href={link.href} style={styles}>{link.label}</a>;
  }
  return <Link to={link.href} style={styles}>{link.label}</Link>;
}

export default function CTABand() {
  const { config } = useSiteConfig();
  const band = config.ctaBand;
  if (!band) return null;

  return (
    <section
      className="hhms-cta-band"
      style={{
        background: config.theme?.heroGradient || COLOR.blue,
        color: '#fff',
        padding: '80px 40px',
      }}
    >
      <style>{`
        @media (max-width: 640px) {
          .hhms-cta-band { padding-left: 20px !important; padding-right: 20px !important; }
        }
      `}</style>
      <div
        style={{
          maxWidth: '100%',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 40,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: '1 1 380px', minWidth: 260 }}>
          <h2
            style={{
              margin: 0,
              fontSize: 28,
              lineHeight: 1.25,
              fontWeight: FONT.weight.xbold,
              letterSpacing: '-0.3px',
            }}
          >
            {band.title}
          </h2>
          {band.subtitle && (
            <p
              style={{
                marginTop: 10,
                marginBottom: 0,
                fontSize: 16,
                lineHeight: 1.55,
                color: 'rgba(255,255,255,0.85)',
              }}
            >
              {band.subtitle}
            </p>
          )}
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {band.ctaPrimary   && <CTA link={band.ctaPrimary}   primary />}
          {band.ctaSecondary && <CTA link={band.ctaSecondary} />}
        </div>
      </div>
    </section>
  );
}
